import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { toast } from "react-toastify";
import { CostPlusEditValidation } from "../../validations/CostPlusValidation";
import { useUserInfo } from "../../layout/provider/Theme";
import {
  fetchComparisonData,
  updateCostPlusValue,
} from "../../api/priceComparison";
import { useCookies } from "react-cookie";

const CostPlusEditModal = ({
  modalForm,
  setModalForm,
  userData,
  isComparePage,
  selectedReport,
  setMaxminRangeForPricing,
  setSelectReportLoader,
  setErrorMessage,
  setProvidedDates,
  setValue,
  onPreferencesUpdate,
  updateCostPlus,
}) => {
  const convertToDate = (timestamp) => new Date(timestamp);
  const [loading, setLoading] = useState(false);
  const { settingsData, handleUserInfo } = useUserInfo();
  const [calendarKey, setCalendarKey] = useState(0);
  const defaultValuesGlobal = {
    prepaidCostPlus: settingsData?.find((item) => item.key === "prepay_cost_plus")?.value,
    creditCostPlus: settingsData?.find((item) => item.key === "credit_cost_plus")?.value,
    prepaidCostPlusLoves: settingsData?.find((item) => item.key === "prepay_cost_plus_loves")?.value,
    creditCostPlusLoves: settingsData?.find((item) => item.key === "credit_cost_plus_loves")?.value,
    costPlus: settingsData?.find((item) => item.key === "cost_plus")?.value,
    distanceRadius: settingsData?.find((item) => item.key === "distance_radius")
      ?.value,
    stateFallback:
      settingsData?.find((item) => item.key === "state_fallback")?.value == 1
        ? "on"
        : "off",
    selectPetro:
      settingsData
        ?.find((item) => item.key === "station")
        ?.value.toLowerCase() || "loves",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(CostPlusEditValidation),
    defaultValues: {
      creditCostPlus: defaultValuesGlobal?.creditCostPlus,
      prepaidCostPlus: defaultValuesGlobal?.prepaidCostPlus,
      creditCostPlusLoves: defaultValuesGlobal?.creditCostPlusLoves,
      prepaidCostPlusLoves: defaultValuesGlobal?.prepaidCostPlusLoves,
      costPlus: defaultValuesGlobal?.costPlus,
      distanceRadius: defaultValuesGlobal?.distanceRadius,
      stateFallback: defaultValuesGlobal?.stateFallback,
      selectPetro: defaultValuesGlobal?.selectPetro,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    if (!updateCostPlus) setSelectReportLoader(false);
    try {
      let updateData = isComparePage
        ? {
          costPlus: data.costPlus,
          distanceRadius: data.distanceRadius,
          stateFallback: data.stateFallback === "on" ? "1" : "0",
          selectPetro: data.selectPetro,
        }
        : {
          creditCostPlus: data.creditCostPlus,
          prepaidCostPlus: data.prepaidCostPlus,
          creditCostPlusLoves: data.creditCostPlusLoves,
          prepaidCostPlusLoves: data.prepaidCostPlusLoves,
        };
      await updateCostPlusValue(updateData);
      // const response = await fetchComparisonData({ id: selectedReport })
      // const { start_date, end_date, pricingFilesDatesArr } = response?.data?.data;

      // const startDate = convertToDate(start_date);
      // const endDate = convertToDate(end_date);
      // const dates = pricingFilesDatesArr.map(convertToDate);

      // setMaxminRangeForPricing({ min: startDate, max: endDate });
      // setProvidedDates(dates);
      // setValue("rangeStartCompare", startDate);
      // setValue("rangeEndCompare", endDate);

      // if (!response?.data?.status) setErrorMessage(response?.data?.message ?? "");
      // else setErrorMessage("");

      // setSelectReportLoader(false);

      if (!updateCostPlus) {
        const response = await fetchComparisonData({
          id: selectedReport,
        });

        const { start_date, end_date, pricingFilesDatesArr } =
          response?.data?.data;
        const startDate = convertToDate(start_date);
        const endDate = convertToDate(end_date);
        const dates = pricingFilesDatesArr.map(convertToDate);

        setMaxminRangeForPricing({ min: startDate, max: endDate });
        setProvidedDates(dates);
        onPreferencesUpdate?.();
        setCalendarKey((prev) => prev + 1);
        if (!response?.data?.status) {
          setErrorMessage(response?.data?.message ?? "");
        } else {
          setErrorMessage("");
        }
      }

      toast.success("Cost plus value updated successfully", {
        position: "top-center",
      });
      toggleForm();
      // userData?.setMutationCall();
      handleUserInfo();
    } catch (error) {
      setSelectReportLoader(false);
      toast.error(error?.response?.data?.message || "An error occurred", {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleForm = () => setModalForm(!modalForm);

  useEffect(() => {
    console.log("reset");
    reset({
      creditCostPlus: defaultValuesGlobal?.creditCostPlus,
      prepaidCostPlus: defaultValuesGlobal?.prepaidCostPlus,
      creditCostPlusLoves: defaultValuesGlobal?.creditCostPlusLoves,
      prepaidCostPlusLoves: defaultValuesGlobal?.prepaidCostPlusLoves,
      costPlus: defaultValuesGlobal?.costPlus,
      distanceRadius: defaultValuesGlobal?.distanceRadius,
      stateFallback: defaultValuesGlobal?.stateFallback,
      selectPetro: defaultValuesGlobal?.selectPetro,
    });
  }, [modalForm]);

  return (
    <Modal isOpen={modalForm}>
      <ModalHeader
        toggle={toggleForm}
        close={
          <button className="close" onClick={toggleForm}>
            {/* <Icon name="cross" /> */}
          </button>
        }
      >
        {isComparePage ? "Compare Preferences" : "Edit Cost Plus Value"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)} noValidate={true}>
          {isComparePage ? (
            <div className="row">
              <div className="form-group">
                <label className="form-label" htmlFor="costPlus">
                  Cost Plus Value
                </label>
                <div className="form-control-wrap">
                  <input
                    type="number"
                    className={`form-control ${errors.costPlus ? "error" : ""}`}
                    id="costPlus"
                    placeholder="Enter cost plus value"
                    {...register("costPlus", {})}
                  />
                  {errors.costPlus && (
                    <span className="custom-invalid">
                      {errors.costPlus.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="distanceRadius">
                  Distance Radius (in miles)
                </label>
                <div className="form-control-wrap">
                  <input
                    type="number"
                    className={`form-control ${errors.distanceRadius ? "error" : ""
                      }`}
                    id="distanceRadius"
                    placeholder="Enter cost plus value"
                    {...register("distanceRadius", {})}
                  />
                  {errors.distanceRadius && (
                    <span className="custom-invalid">
                      {errors.distanceRadius.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="costPlus">
                  State Fallback
                </label>
                <ul className="custom-control-group g-3 align-center">
                  <li>
                    <div className="custom-control custom-radio custom-control-pro no-control checked">
                      <input
                        type="radio"
                        className="custom-control-input"
                        {...register("stateFallback", {})}
                        value="on"
                        id="stateBtnRadio1"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="stateBtnRadio1"
                      >
                        On
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="custom-control custom-radio custom-control-pro no-control checked">
                      <input
                        type="radio"
                        className="custom-control-input"
                        {...register("stateFallback", {})}
                        value="off"
                        id="stateBtnRadio2"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="stateBtnRadio2"
                      >
                        Off
                      </label>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="selectPetro">
                  Station Type
                </label>
                <ul className="custom-control-group g-3 align-center">
                  <li>
                    <div className="custom-control custom-radio custom-control-pro no-control">
                      <input
                        type="radio"
                        className="custom-control-input"
                        {...register("selectPetro", {})}
                        value="loves"
                        id="petroLoves"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="petroLoves"
                      >
                        Loves
                      </label>
                    </div>
                  </li>
                  <li>
                    <div className="custom-control custom-radio custom-control-pro no-control">
                      <input
                        type="radio"
                        className="custom-control-input"
                        {...register("selectPetro", {})}
                        value="ta_petro"
                        id="petroTA"
                      />
                      <label className="custom-control-label" htmlFor="petroTA">
                        TA Petro
                      </label>
                    </div>
                  </li>
                </ul>
                {errors.selectPetro && (
                  <span className="custom-invalid">
                    {errors.selectPetro.message}
                  </span>
                )}
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-6 mb-2">
                <div className="form-group">
                  <label className="form-label" htmlFor="creditCostPlus">
                    Credit Cost Plus - TA Petro
                  </label>
                  <div className="form-control-wrap">
                    <input
                      step={0.123}
                      type="number"
                      className={`form-control ${errors.creditCostPlus ? "error" : ""
                        }`}
                      id="creditCostPlus"
                      placeholder="Enter cost plus value"
                      {...register("creditCostPlus", {})}
                    />
                    {errors.creditCostPlus && (
                      <span className="custom-invalid">
                        {errors?.creditCostPlus?.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-6 mb-2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="creditCostPlusLoves">
                      Credit Cost Plus - Loves
                    </label>
                    <div className="form-control-wrap">
                      <input
                        step={0.123}
                        type="number"
                        className={`form-control ${errors.creditCostPlusLoves ? "error" : ""
                          }`}
                        id="creditCostPlusLoves"
                        placeholder="Enter cost plus value"
                        {...register("creditCostPlusLoves", {})}
                      />
                      {errors.creditCostPlusLoves && (
                        <span className="custom-invalid">
                          {errors?.creditCostPlusLoves?.message}
                        </span>
                      )}
                    </div>
                  </div>
              </div>
              <div className="col-6 mb-2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="prepaidCostPlus">
                      Prepaid Cost Plus - TA Petro
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="number"
                        className={`form-control ${errors.prepaidCostPlus ? "error" : ""
                          }`}
                        id="prepaidCostPlus"
                        placeholder="Enter cost plus value"
                        {...register("prepaidCostPlus", {})}
                      />
                      {errors.prepaidCostPlus && (
                        <span className="custom-invalid">
                          {errors.prepaidCostPlus.message}
                        </span>
                      )}
                    </div>
                  </div>
              </div>
              <div className="col-6 mb-2">
                  <div className="form-group">
                    <label className="form-label" htmlFor="prepaidCostPlusLoves">
                      Prepaid Cost Plus - Loves
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="number"
                        className={`form-control ${errors.prepaidCostPlusLoves ? "error" : ""
                          }`}
                        id="prepaidCostPlusLoves"
                        placeholder="Enter cost plus value"
                        {...register("prepaidCostPlusLoves", {})}
                      />
                      {errors.prepaidCostPlusLoves && (
                        <span className="custom-invalid">
                          {errors.prepaidCostPlusLoves.message}
                        </span>
                      )}
                    </div>
                  </div>
              </div>
            </div>
          )}
          <Row className="justify-content-end mx-auto">
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="white"
                    size="lg"
                    onClick={toggleForm}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Col>
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="primary"
                    type="submit"
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? <Spinner color="white" size="sm" /> : "Update"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CostPlusEditModal;
